import SearchForm from '../../model/search-form';

export default class WebReturnsSidebar implements SearchForm {
  private readonly activeFormSwitch: JQuery;
  private readonly basicSearch: JQuery;
  private readonly detailedSearch: JQuery;

  private readonly period: JQuery;
  private readonly dateFromHidden: JQuery;
  private readonly dateUntilHidden: JQuery;
  private readonly dateFrom: JQuery;
  private readonly dateUntil: JQuery;
  private readonly orderStatus: JQuery;

  private readonly searchTermSelect: JQuery;
  private readonly searchTerm: JQuery;

  private readonly printForm: JQuery;

  constructor(private readonly container: JQuery<HTMLFormElement>) {
    this.activeFormSwitch = this.container.find('.js-sidebarSwitch');
    this.basicSearch = this.container.find('.js-basicSearch');
    this.detailedSearch = this.container.find('.js-detailedSearch');

    this.period = this.basicSearch.find('.js-period');
    this.orderStatus = this.container.find('.js-orderStatus');

    this.dateFromHidden = this.basicSearch.find('.js-dateFromHidden');
    this.dateUntilHidden = this.basicSearch.find('.js-dateUntilHidden');

    this.dateFrom = this.detailedSearch.find('.js-dateFrom');
    this.dateUntil = this.detailedSearch.find('.js-dateUntil');

    this.searchTermSelect = this.basicSearch.find('.js-searchTermSelect');
    this.searchTerm = this.basicSearch.find('.js-searchTerm');

    this.printForm = $('.js-printForm');

    this.bindSwitchChange();
    this.bindPeriodChange();

    this.setActiveForm();
    this.cloneSubmittedForm();
  }

  getForm(): JQuery<HTMLFormElement> {
    return this.container;
  }

  submit(): void {
    this.container.submit();
  }

  private bindSwitchChange(): void {
    this.activeFormSwitch.on('change', (): void => {
      if (this.isDetailFormActive()) {
        this.activateDetailedForm();
      } else {
        this.activateBasicForm();
      }
    });
  }

  private bindPeriodChange(): void {
    this.period.on('change', (): void => {
      this.setPeriod();
    });
  }

  private copyPeriodToFromAndUntil(): void {
    const selectedPeriodOption = this.getSelectedPeriodOption();
    if (selectedPeriodOption.data('from').length && selectedPeriodOption.data('until').length) {
      this.dateFrom.datepicker('setDate', new Date(selectedPeriodOption.data('from')));
      this.dateUntil.datepicker('setDate', new Date(selectedPeriodOption.data('until')));
    } else {
      this.dateFrom.datepicker('setDate', null);
      this.dateUntil.datepicker('setDate', null);
    }
    this.dateFrom.trigger('change');
    this.dateUntil.trigger('change');
  }

  private copySearchTerm(): void {
    this.detailedSearch.find(`[name="${this.getSelectedSearchTerm()}"]`).val(this.searchTerm.val() as string);
  }

  private setPeriod(): void {
    this.dateFromHidden.val(this.getSelectedPeriodOption().data('from'));
    this.dateUntilHidden.val(this.getSelectedPeriodOption().data('until'));
  }

  private activateDetailedForm(): void {
    this.basicSearch.addClass('d-none');
    this.detailedSearch.removeClass('d-none');
    WebReturnsSidebar.clearForm(this.detailedSearch);
    WebReturnsSidebar.enableForm(this.detailedSearch);
    WebReturnsSidebar.disableForm(this.basicSearch);
    this.copyPeriodToFromAndUntil();
    this.copySearchTerm();
  }

  private activateBasicForm(): void {
    this.basicSearch.removeClass('d-none');
    this.detailedSearch.addClass('d-none');
    WebReturnsSidebar.clearForm(this.basicSearch);
    WebReturnsSidebar.enableForm(this.basicSearch);
    WebReturnsSidebar.disableForm(this.detailedSearch);
    this.resetPeriodToDefault();
  }

  private setActiveForm(): void {
    if (this.isDetailFormActive()) {
      WebReturnsSidebar.disableForm(this.basicSearch);
    } else {
      WebReturnsSidebar.disableForm(this.detailedSearch);
    }
  }

  private isDetailFormActive(): boolean {
    return this.activeFormSwitch.is(':checked');
  }

  static clearForm(form: JQuery): void {
    form.find('input, select').val('');
  }

  static disableForm(form: JQuery): void {
    form.find('input, select').prop('disabled', true);
  }

  static enableForm(form: JQuery): void {
    form.find('input, select').prop('disabled', false);
  }

  private getSelectedPeriodOption(): JQuery {
    return this.period.find('option:selected');
  }

  private resetPeriodToDefault(): void {
    this.period.val(this.period.find('option[data-default="true"]').val() as string);
    this.setPeriod();
  }

  private getSelectedSearchTerm(): string {
    const term = this.searchTermSelect.val() as string;
    return term.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
  }

  private cloneSubmittedForm(): void {
    this.printForm.append(this.orderStatus.html());
    this.printForm.append(this.isDetailFormActive() ? this.detailedSearch.html() : this.basicSearch.html());
  }

}
